module.exports = __webpack_public_path__ + "img/14.604c56cc.jpg";